import {EventEmitter, Injectable} from '@angular/core';
import {LierConsultationPlaceModalComponent} from '../../../../modals/lier-consultation-place-modal/lier-consultation-place-modal.component';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BehaviorSubject, combineLatest, forkJoin, Subject, Subscription} from 'rxjs';
import {filter, switchMap} from 'rxjs/operators';
import {Avis} from '../../../../../../models/avis';
import {JsonContentEnum} from '../../../../../../models/enums/json-content.enum';
import {AvisService} from '../../../../../avisDePub/services/avis-service';
import {
  PopupChangeComponent
} from '../../../../../avisDePub/visualiser-avis-de-pub/popup-change/popup-change.component';
import {
  PopupDupliquerComponent
} from '../../../../../avisDePub/visualiser-avis-de-pub/popup-dupliquer/popup-dupliquer.component';
import {
  PopupSupprimerComponent
} from '../../../../../avisDePub/visualiser-avis-de-pub/popup-supprimer/popup-supprimer.component';
import {FormulaireServiceService} from '../../../../../formulaires/services/formulaire-service.service';
import {EformAvisLiesType} from '../../../../models/enum/eformAvisLiesType';
import {CanNavigateInStepperService} from '../../../../services/can-navigate-in-stepper.service';
import {LogService} from '../../../../services/log.service';
import {FormsEnum} from '../../../../../../models/enums/forms.enum';
import {Endpoints} from '../../../../../../models/endpoints';
import {SessionService} from '../../../../../administration/services/session.service';
import {HttpService} from '../../../../services/http.service';
import {StepperBuilderService} from '../../../../../avisDePub/creer/services/stepper.builder.service';
import {EformPrefillService} from '../../../../../formulaires/eforms/services/eform-prefill.service';
import {AvisDataTransferService} from '../../../../services/avis-data-transfer.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { EformsExtractorService } from '../../../../../formulaires/eforms/services/eforms-extractor.service';
import { EformConditionsV2Service } from '../../../../../formulaires/eforms/services/eform-conditions-v2.service';

@Injectable({
  providedIn: 'root'
})
export class TableActionService {

  private LOG: LogService = new LogService(TableActionService);
  private subscriptions = new Subscription();
  public liables: BehaviorSubject<any> = new BehaviorSubject([]);
  public reliables: BehaviorSubject<any> = new BehaviorSubject([]);
  public canBeLier: BehaviorSubject<any> = new BehaviorSubject(false);
  public avis: BehaviorSubject<any> = new BehaviorSubject(null);
  public suppressionAvisEffect = new Subject<string>();


  obsAvisLies: Subscription;


  constructor(private router: Router,
              private canNavigateInStepperService: CanNavigateInStepperService,
              private modalService: NgbModal,
              private avisService: AvisService,
              private formulaireService: FormulaireServiceService,
              private httpService: HttpService,
              private session: SessionService,
              private stepperBuilderService: StepperBuilderService,
              private eformPrefillService: EformPrefillService,
              private avisDataTransferService: AvisDataTransferService,
              private spinner: SpinnerVisibilityService,
              private eformsExtractorService: EformsExtractorService,
              private eformConditionsV2Service: EformConditionsV2Service
  ) {
  }

  public getAction(event: any) {
    let r = new EventEmitter<boolean>(undefined);
    const reference = event.data.numero;
    switch (event.action.type) {
      case 'boamp':
        window.open(event.data.urlBoamp, '_blank');
        r.emit(false);
        break;
      case 'Visualiser':
        this.canNavigateInStepperService.selectedAvisItemData = event.data;
        this.canNavigateInStepperService.currentFormulaire = event.data.formulairecode;
        this.stepperBuilderService.formulaire = event.data.formulairecode
        this.canNavigateInStepperService.currentNormeFormulaire = event.data.norme;
        this.canNavigateInStepperService.linkableNotices = event.reliables;
        forkJoin({
          avis: this.avisService.getAvisByReference(event.data.numero),
          connexe: this.avisService.getAvisByReferenceAvisConnexe(event.data.numero)
        }).subscribe(data => {
          data.avis.flux = data.avis.flux.concat(data.connexe.flux);
          this.canNavigateInStepperService.setReferenceParent(data.avis);
          this.canNavigateInStepperService.linkableNotices = [data.avis];
        });
        this.canNavigateInStepperService.selectedDiffuseurInitial = event.data.diffuseurs;
        this.canNavigateInStepperService.linkableForms = event.liables;
        this.canNavigateInStepperService.formulairevalues = event.data.formulairevalues;
        this.router.navigate(['/avisdepublicite/visualiser/' + event.data.numero]);
        r.emit(false);
        break;
      case 'Editer':
        this.spinner.show();
        this.canNavigateInStepperService.currentFormulaire = event.data.formulairecode;
        this.canNavigateInStepperService.currentNormeFormulaire = event.data.norme;
        this.canNavigateInStepperService.isEditAvisSelected = true;
        if (!event.data.formulairecode.startsWith("E_")) {
          this.canNavigateInStepperService.isAvisLierNational = true;
        }
        if (event.data.isLie) {
          this.canNavigateInStepperService.isCreerAvisLierSelected = true;
          this.canNavigateInStepperService.isEdit = true;
        }
        this.canNavigateInStepperService.eformMotifChange = event.data.motif
        this.router.navigate(['/avisdepublicite/editerAvisPub/' + event.data.numero]);
        r.emit(false);
        break;
      case 'Declarer':
        this.canNavigateInStepperService.isCreerAvisLierSelected = true;
        combineLatest([
          this.avisService.getAvisByReference(reference),
          this.avisService.getAvisByReferenceAvisConnexe(reference)
        ])
          .pipe(
            switchMap(data => {
              const [primaryAvis, secondaryAvis] = data;
              primaryAvis.flux = primaryAvis.flux.concat(secondaryAvis.flux);
              if (!data[0].formulaire.code.startsWith("E_"))
                this.canNavigateInStepperService.isAvisLierNational = true;
              this.canNavigateInStepperService.setReferenceParent(primaryAvis);
              const formCode = this.getFormCodeDeclarer(primaryAvis.formulaire.code);
              return this.formulaireService.getAvis(null, formCode, JsonContentEnum.EMPTY, primaryAvis.reference)
                .pipe(
                  switchMap(avis =>
                    this.stepperBuilderService.initDefaultJsonErrors('assets/data/errors/lieForms/' + FormsEnum[formCode] + '.json')
                      .pipe(
                        switchMap(json => {
                          avis.jsonFieldsErrorsWarnings = json;
                          avis.jsonCSV = {};
                          this.setPDFAvisLiesV1(avis.formulaire.code);
                          return this.formulaireService.create(avis, avis.refAvisLie, false)
                        })
                      )
                  )
                );
            })
          )
          .subscribe((createdAvis: Avis) => {
            this.router.navigate(['/avisdepublicite/editerAvisPub/' + createdAvis.reference]);
            r.emit(false);
          });
        break;
      case 'Annuler':
        this.canNavigateInStepperService.isCreerAvisLierSelected = true;
        combineLatest([
          this.avisService.getAvisByReference(reference),
          this.avisService.getAvisByReferenceAvisConnexe(reference)
        ])
          .pipe(
            switchMap(data => {
              const [primaryAvis, secondaryAvis] = data;
              primaryAvis.flux = primaryAvis.flux.concat(secondaryAvis.flux);
              if (!data[0].formulaire.code.startsWith("E_"))
                this.canNavigateInStepperService.isAvisLierNational = true;
              this.canNavigateInStepperService.setReferenceParent(primaryAvis);
              const formCode = this.getFormCodeAnnuler(primaryAvis.formulaire.code);
              return this.formulaireService.getAvis(null, formCode, JsonContentEnum.EMPTY, primaryAvis.reference)
                .pipe(
                  switchMap(avis =>
                    this.stepperBuilderService.initDefaultJsonErrors('assets/data/errors/lieForms/' + FormsEnum[formCode] + '.json')
                      .pipe(
                        switchMap(json => {
                          avis.jsonFieldsErrorsWarnings = json;
                          avis.jsonCSV = {};
                          this.setPDFAvisLiesV1(avis.formulaire.code);
                          return this.formulaireService.create(avis, avis.refAvisLie, false);
                        })
                      )
                  )
                );
            })
          )
          .subscribe(createdAvis => {
            this.router.navigate(['/avisdepublicite/editerAvisPub/' + createdAvis.reference]);
            r.emit(false);
          });
        break;
      case 'Rectifier':
        this.canNavigateInStepperService.isCreerAvisLierSelected = true;
        combineLatest([
          this.avisService.getAvisByReference(reference),
          this.avisService.getAvisByReferenceAvisConnexe(reference)
        ])
          .pipe(
            switchMap(data => {
              const [primaryAvis, secondaryAvis] = data;
              primaryAvis.flux = primaryAvis.flux.concat(secondaryAvis.flux);
              if (!data[0].formulaire.code.startsWith("E_"))
                this.canNavigateInStepperService.isAvisLierNational = true;
              this.canNavigateInStepperService.setReferenceParent(primaryAvis);
              const formCode = this.getFormCodeRectifier(primaryAvis.formulaire.code);
              return this.formulaireService.getAvis(null, formCode, JsonContentEnum.EMPTY, primaryAvis.reference)
                .pipe(
                  switchMap(avis =>
                    this.stepperBuilderService.initDefaultJsonErrors('assets/data/errors/lieForms/' + FormsEnum[formCode] + '.json')
                      .pipe(
                        switchMap(json => {
                          avis.jsonFieldsErrorsWarnings = json;
                          avis.jsonCSV = {};
                          this.setPDFAvisLiesV1(avis.formulaire.code);
                          return this.formulaireService.create(avis, avis.refAvisLie,false);
                        })
                      )
                  )
                );
            })
          )
          .subscribe(createdAvis => {
            this.router.navigate(['/avisdepublicite/editerAvisPub/' + createdAvis.reference]);
            r.emit(false);
          });
        break;
      case 'Lier':
        this.canNavigateInStepperService.currentFormulaire = event.data.formulairecode;
        this.canNavigateInStepperService.currentNormeFormulaire = event.data.norme;
        this.canNavigateInStepperService.linkableNotices = event.reliables;
        this.canNavigateInStepperService.isEditAvisSelected = false;
        this.canNavigateInStepperService.isCreerAvisLierSelected = true;
        this.canNavigateInStepperService.avisLieModalite = 2;

        if (!event.data.formulairecode.includes('E_FORM')) {
          this.canNavigateInStepperService.isAvisLierNational = true;
        }
        this.canNavigateInStepperService.creerAvisLierSelected = true;
        this.router.navigate(['/avisdepublicite/editerAvisPub/' + event.data.numero]);
        r.emit(false);
        break;
      case 'Dupliquer':
        this.subscriptions.add(
          this.avisService.duplicate(event.data.numero).subscribe(
            (data: Avis) => {
              this.avisDataTransferService.sourceAppProfilAcheteurInfos = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos;
              // 🔧 FIX 2026-04-22: Réinitialiser les flatFields pour éviter les données fantômes
              // lors de l'édition de l'avis dupliqué (alignement avec visualiser-avis-de-pub.component.ts)
              this.eformConditionsV2Service.resetFlatFields();
              this.modalService.open(PopupDupliquerComponent)
              r.emit(true);
            },
            (error) => {
              this.LOG.error(error);
              r.emit(false);
            })
        );
        break;
      case 'Supprimer':
        const modalRefR = this.modalService.open(PopupSupprimerComponent);
        modalRefR.componentInstance.idAvis = event.data.numero;
        modalRefR.componentInstance.referenceAvis = event.data.numero;
        modalRefR.componentInstance.confirm.subscribe(() => {
          this.httpService.delete(Endpoints.AVIS_DELETE + event.data.numero).subscribe({
            next: () => {
              this.suppressionAvisEffect.next(event.data.numero);
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate(['avisdepublicite/listerAvisPub']);
              });
            },
            error: (error) => this.LOG.error(error)
          });
        });
        break;
      case 'Télécharger':
        //Génération du pdf à partir du numéro de référence
        // todo MBO: fix recuperation de la langue, par defaut "" = fr
        // this.avisService.generatePdf(event.data.numero, this.translateService.currentLang).subscribe((data) => {
        this.avisService.generatePdf(event.data.numero, "fr").subscribe((data) => {
            let file = new Blob([data], {type: 'application/pdf'});
            let fileURL = URL.createObjectURL(file);
            //download
            const anchor = document.createElement('a');
            anchor.download = event.data.numero + '.pdf';
            anchor.href = fileURL;
            anchor.click();
            r.emit(false);
          },
          (error) => {
            this.LOG.error(error);
            r.emit(false);
          });
        break;
      case 'TéléchargerXML':
        this.avisService.getAvisByReference(reference).subscribe(data => {
          if (!data.formulaire.code.includes('E_FORM')) {
            this.formulaireService.exportXmlAvis(data);
          } else {
            this.formulaireService.exportXmlEform(data);
          }
        });
        break;
      case 'LierConsultationPlace':
        this.avisService.getAvisByReference(reference).subscribe(avis => {
          const refConsultation = this.canNavigateInStepperService.reference || sessionStorage.getItem('referenceConsultation');
          const modalRef = this.modalService.open(LierConsultationPlaceModalComponent);
          modalRef.componentInstance.referenceAvis = avis.reference;
          modalRef.componentInstance.objetAvis = avis.intituleDuMarche ?? avis.critere?.typeMarche?.libelle;
          modalRef.componentInstance.familleFormulaire = avis.formulaire?.intitule;
          modalRef.componentInstance.refConsultation = refConsultation;
          modalRef.result.then((confirmed: boolean) => {
            if (confirmed && refConsultation) {
              avis.refConsultation = refConsultation;
              this.formulaireService.update(avis, null, true).subscribe({
                next: () => r.emit(true),
                error: (error) => { this.LOG.error(error); r.emit(false); }
              });
            } else {
              r.emit(false);
            }
          }).catch(() => r.emit(false));
        });
        break;
      case 'change':
        const modalRef = this.modalService.open(PopupChangeComponent)
        modalRef.componentInstance.motif.subscribe({
          next: (motif: any) => {
            const endMotif = motif.split('.').pop();
            this.avisService.change(event.data.numero, endMotif).subscribe({
              next: ((e: Avis) => {
                this.canNavigateInStepperService.currentFormulaire = event.data.formulairecode;
                this.canNavigateInStepperService.currentNormeFormulaire = event.data.norme;
                this.canNavigateInStepperService.isEditAvisSelected = true;
                this.canNavigateInStepperService.eformMotifChange = 'eform-not-editable.code|name|change-corrig-justification.' + e.motifModification;
                this.canNavigateInStepperService.eformCreatingChange = true;
                // Récupérer l'idAnnEmetteur de l'avis parent retourné par le backend
                this.avisService.getAvisByReference(event.data.numero).subscribe({
                  next: (parentAvis: Avis) => {
                    // Utiliser l'idAnnEmetteur du parent direct au lieu de eformIdParentNotice
                    this.canNavigateInStepperService.eformIdParentNotice = parentAvis.jsonSaisieFormulaire?.ann?.idAnnEmetteur || event.data.eformIdParentNotice;
                    this.router.navigate(['/avisdepublicite/editerAvisPub/' + e.reference]);
                  },
                  error: (error) => {
                    // En cas d'erreur, utiliser la valeur par défaut
                    this.canNavigateInStepperService.eformIdParentNotice = event.data.eformIdParentNotice;
                    this.router.navigate(['/avisdepublicite/editerAvisPub/' + e.reference]);
                  }
                });
              }),
              error: ((error) => {
                this.LOG.error(error);
                r.emit(false);
              })
            })
          }
        });
        break;
      case 'Corriger':
        this.subscriptions.add(
          this.avisService.corrigerAvis(event.data.numero).subscribe(
            (data: Avis) => {
              this.avisDataTransferService.sourceAppProfilAcheteurInfos = data.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos;
              const modalCorriger = this.modalService.open(PopupDupliquerComponent)
              modalCorriger.componentInstance.isCorriger = true;
              this.canNavigateInStepperService.currentFormulaire = data.formulaire.code;
              this.canNavigateInStepperService.currentNormeFormulaire = data.formulaire.typeNorme;
              this.canNavigateInStepperService.isEditAvisSelected = true;
              if (!data.formulaire.code.startsWith("E_")) {
                this.canNavigateInStepperService.isAvisLierNational = true;
              }
              if (event.data.isLie) {
                this.canNavigateInStepperService.isCreerAvisLierSelected = true;
                this.canNavigateInStepperService.isEdit = true;
              }
              this.canNavigateInStepperService.eformMotifChange = data.motifModification
              this.spinner.show();
              this.router.navigate(['/avisdepublicite/editerAvisPub/' + data.reference]);
              r.emit(true);
            },
            (error) => {
              this.LOG.error(error);
              r.emit(false);
            })
        );
        break;
      default:
        if (event.action.type === EformAvisLiesType.CONCURRENCE || event.action.type === EformAvisLiesType.CONCURRENCE_ASSOUPLI || event.action.type === EformAvisLiesType.MODIF_MARCHE || event.action.type === EformAvisLiesType.RESULTAT) {
          // Création avis liés eform
          this.canNavigateInStepperService.isCreerAvisLierSelected = true;
          this.canNavigateInStepperService.isEditAvisSelected = true;
          this.eformPrefillService.codeOrigine = event.data.formulairecode.toString();
          this.canNavigateInStepperService.avisLieModalite = 1;
          combineLatest([
            this.avisService.getAvisByReference(reference),
            this.avisService.getAvisByReferenceAvisConnexe(reference)
          ])
            .pipe(
              switchMap(data => {
                const [primaryAvis, secondaryAvis] = data;
                primaryAvis.flux = primaryAvis.flux.concat(secondaryAvis.flux);
                const formCode = this.canNavigateInStepperService.referentielEformAvisLies.filter(e => e.form === primaryAvis?.formulaire?.code && e.typeAvisLies === event.action.type).map(e => e.formLinkable)[0];
                this.canNavigateInStepperService.setReferenceParent(primaryAvis);
                let newAvis: Avis = JSON.parse(JSON.stringify(primaryAvis));
                newAvis.jsonPdf = null;
                newAvis.jsonFieldsErrorsWarnings = null;
                newAvis.jsonCSV = null;
                newAvis.avisId = null;
                newAvis.jsonSaisieFormulaire.ann.businessRegistrationInformationNotice = null;
                newAvis.jsonSaisieFormulaire.ann.priorInformationNotice = null;
                newAvis.jsonSaisieFormulaire.ann.contractAwardNotice = null;
                newAvis.jsonSaisieFormulaire.ann.contractNotice = null;
                newAvis.reference = null;
                newAvis.formulaire.code = formCode;
                newAvis.refAvisLie = primaryAvis.reference;
                newAvis.critere.montantMarche.code = null;
                newAvis.critere.typeMarche.code = null;
                newAvis.critere.typeOrganisme.code = null;
                this.eformsExtractorService.setAvisCritere(formCode,newAvis)
                this.recupContractFolderId(primaryAvis)
                this.canNavigateInStepperService.isAvisLieCreate = true;
                this.canNavigateInStepperService.avisLieCreateFirstSave = true;
                this.canNavigateInStepperService.avisIdParent = primaryAvis.avisId;
                // PRB0052503: F16->F29 5 lots - Perte de saisie des critères d'attribution et messages d'erreur non conformes
                this.canNavigateInStepperService.avisFormCodeParent = primaryAvis.formulaire.code;
                this.canNavigateInStepperService.idParentFluxBoampEform = primaryAvis.flux.filter(e=>e.fluxBoamp)[0].fluxBoamp?.idPublicationEForms;
                return this.formulaireService.create(newAvis, primaryAvis.reference, false);
              })
            )
            .subscribe(createdAvis => {
              this.router.navigate(['/avisdepublicite/editerAvisPub/' + createdAvis.reference]);
              r.emit(false);
            });
        }
        break;
    }
    return r;
  }

  recupContractFolderId(primaryAvis) {
    let contractFolderId;
    if (primaryAvis.jsonSaisieFormulaire.ann.priorInformationNotice) {
      contractFolderId = primaryAvis.jsonSaisieFormulaire.ann.priorInformationNotice.contractFolderID?.val
    }
    if (primaryAvis.jsonSaisieFormulaire.ann.contractAwardNotice) {
      contractFolderId = primaryAvis.jsonSaisieFormulaire.ann.contractAwardNotice.contractFolderID?.val
    }
    if (primaryAvis.jsonSaisieFormulaire.ann.contractNotice) {
      contractFolderId = primaryAvis.jsonSaisieFormulaire.ann.contractNotice.contractFolderID?.val
    }
    this.formulaireService.actualFormContractFolderId.next(contractFolderId);
  }

  setPDFAvisLiesV1(form: string) {
    this.stepperBuilderService.PDFAvisLiesSetted.pipe(filter(objJson => objJson != null)).subscribe(objJson => {
        switch (form) {
          case 'MAPA_AT': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'MAPA_AN': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.annulationFromMAPA.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.annulationFromMAPA.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'MAPA_RE': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.rectificatifFromMAPA.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.mapa.rectificatifFromMAPA.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'SIMP_AT': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.attribution.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.attribution.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'SIMP_AN': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.annulationFromFNSimple.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.annulationFromFNSimple.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'SIMP_RE': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.rectificatifFromFNSimple.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.fnSimple.rectificatifFromFNSimple.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'DIVE_AT': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.divers.attribution.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.divers.attribution.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'DIVE_AN': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.divers.annulation.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.divers.annulation.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          case 'DIVE_RE': {
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[3].value = objJson.formData.jsonSaisieFormulaire.ann.divers.rectificatif.avisInitial.idWeb;
            this.avisDataTransferService.contenuPdf.champs._STEP_ID_1[4].value = objJson.formData.jsonSaisieFormulaire.ann.divers.rectificatif.avisInitial.datePublication;
            this.stepperBuilderService.prefillDone.next(true);
            break;
          }
          default:
            break;
        }

      },
      (error) => {
        console.error('Error loading errors.json', error);
      });
  }

  getAvisLies(referenceAvis: string,formulairecode :string) {
    this.obsAvisLies = this.httpService.get(
      Endpoints.AVIS_LIABLES +
      Endpoints.GET_ONE_PARAM1 +
      referenceAvis +
      Endpoints.IS_EFORM +
        formulairecode?.includes('E_FORM')
    )
      .subscribe((data: any[]) => {
          if (data) {
            this.reliables.next(data);
          }
        },
        (error) => {
          this.LOG.error(error);
        });

    this.obsAvisLies = this.httpService.get(
      Endpoints.AVIS_MOD1_CHECK +
      Endpoints.GET_ONE_PARAM1 +
      referenceAvis
    )
      .subscribe((data: any[]) => {
          if (data) {
            this.canBeLier.next(data);
          }
        },
        (error) => {
          this.LOG.error(error);
        });


  }

  private getFormCodeDeclarer(formulaireCode) {
    switch (formulaireCode) {
      case 'DIVE_IN':
        return FormsEnum.DIVE_AT;
      case 'MAPA_IN':
        return FormsEnum.MAPA_AT;
      case 'SIMP_IN':
        return FormsEnum.SIMP_AT;
      default:
        break;
    }
  }

  private getFormCodeAnnuler(formulaireCode) {
    switch (formulaireCode) {
      case 'DIVE_IN':
        return FormsEnum.DIVE_AN;
      case 'MAPA_IN':
        return FormsEnum.MAPA_AN;
      case 'SIMP_IN':
        return FormsEnum.SIMP_AN;
      case 'DIVE_AT':
        return FormsEnum.DIVE_AN;
      case 'MAPA_AT':
        return FormsEnum.MAPA_AN;
      case 'SIMP_AT':
        return FormsEnum.SIMP_AN;
      case 'DIVE_RE':
        return FormsEnum.DIVE_AN;
      case 'MAPA_RE':
        return FormsEnum.MAPA_AN;
      case 'SIMP_RE':
        return FormsEnum.SIMP_AN;
      default:
        break;
    }
  }

  private getFormCodeRectifier(formulaireCode) {
    switch (formulaireCode) {
      case 'DIVE_IN':
        return FormsEnum.DIVE_RE;
      case 'MAPA_IN':
        return FormsEnum.MAPA_RE;
      case 'SIMP_IN':
        return FormsEnum.SIMP_RE;
      case 'DIVE_AT':
        return FormsEnum.DIVE_RE;
      case 'MAPA_AT':
        return FormsEnum.MAPA_RE;
      case 'SIMP_AT':
        return FormsEnum.SIMP_RE;
      default:
        break;
    }
  }

}

